import { atomWithReset } from "jotai/utils";

export const isDiscardMeasurementModeActiveAtom = atomWithReset(false);
